"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const react_1 = __importDefault(require("react"));
const spa_core_1 = require("@episerver/spa-core");
require("./Footer.scss");
const Link_1 = __importStar(require("../../Components/Common/Link"));
const Footer = (props) => {
    var _a, _b, _c;
    const target = props.settings.contactUsLink.linkTarget.value === '_blank' ? Link_1.LinkTarget.New_window : Link_1.LinkTarget.Current_window;
    const type = Link_1.LinkType[props.settings.contactUsLink.linkType.value];
    const socialLinks = [];
    const createSocialLink = (link) => {
        var _a;
        const url = new URL(link.href);
        let offDomain = true;
        try {
            if (window.location.protocol !== url.protocol && window.location.host === url.host)
                url.protocol = window.location.protocol;
            offDomain = window.location.host !== url.host;
        }
        catch (e) {
            // Ignored on purpose
        }
        const linkProps = {
            title: link.title,
            target: link.target,
            className: 'fw-normal my-4',
            href: url.href
        };
        const key = `footer.${link.title}.link.${((_a = link.contentLink) === null || _a === void 0 ? void 0 : _a.id) || link.href}`;
        if (offDomain) {
            linkProps.rel = 'noreferrer';
        }
        linkProps.className = 'nav-item d-inline-flex align-items-center';
        let icon = react_1.default.createElement(react_1.default.Fragment, null);
        if (link.href.includes('facebook'))
            icon = react_1.default.createElement("i", { className: 'icon-logo-facebook' });
        else if (link.href.includes('instagram'))
            icon = react_1.default.createElement("i", { className: 'icon-logo-instagram' });
        else if (link.href.includes('linkedin'))
            icon = react_1.default.createElement("i", { className: 'icon-logo-linkedin' });
        else if (link.href.includes('twitter'))
            icon = react_1.default.createElement("i", { className: 'icon-logo-x' });
        return react_1.default.createElement("div", { className: 'nav-item d-block', key: key },
            react_1.default.createElement("a", Object.assign({}, linkProps),
                react_1.default.createElement("span", { className: 'visually-hidden' }, link.text),
                icon));
    };
    (_b = (_a = props.settings.socialLinks) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.forEach(x => {
        socialLinks.push(createSocialLink(x));
    });
    const linkVar = {
        renderAsListElement: true, listItemClass: ''
    };
    return react_1.default.createElement("footer", { className: 'footer text-center text-md-start', key: 'SampoFooter' },
        react_1.default.createElement("div", { className: 'row g-0 justify-content-lg-end' },
            react_1.default.createElement("div", { className: "col-12 content-padding" },
                react_1.default.createElement("div", { className: 'row footer-content justify-content-md-between' },
                    react_1.default.createElement("div", { className: 'col-12 col-md-6 mt-md-4' },
                        react_1.default.createElement("img", { loading: 'lazy', className: 'logo mt-10 mb-8', alt: 'Sampo Group Logo', src: '/spaview/app.html.spa/Sampo_logo_white.svg', width: 180, height: 50 }),
                        react_1.default.createElement("p", { className: 'address mx-auto mx-md-0 mb-md-0' },
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.settings, field: "companyAddress" })),
                        react_1.default.createElement("p", { className: 'desc my-9 px-2 px-md-0 mx-auto mx-md-0 mt-md-10 mb-md-11' },
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.settings, field: "introduction" }))),
                    react_1.default.createElement("div", { className: 'col-12 col-md-5 mt-md-10 ps-xl-9' },
                        react_1.default.createElement("div", { className: 'links mb-3' },
                            react_1.default.createElement("nav", { className: 'row justify-content-md-between' },
                                react_1.default.createElement("ul", { className: "col-12 col-md-auto d-flex flex-column" },
                                    react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.settings.footerLinks, propertyName: "footerLinks", noWrap: true, parentVar: linkVar })),
                                react_1.default.createElement("ul", { className: "col-12 col-md-auto d-flex flex-column" },
                                    react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.settings.footerLinksRight, propertyName: "footerLinksRight", noWrap: true, parentVar: linkVar })))),
                        react_1.default.createElement("div", { className: 'mt-3 mb-9 d-inline-block' }, type != undefined ? react_1.default.createElement(Link_1.default, { documents: props.settings.contactUsLink.documentLinks != null ? props.settings.contactUsLink.documentLinks.value : undefined, href: props.settings.contactUsLink.href != null ? props.settings.contactUsLink.href.value : undefined, target: target, title: props.settings.contactUsLink.linkTitle != null ? props.settings.contactUsLink.linkTitle.value : '', type: type, icon_class: (_c = props.settings.contactUsLink.iconClass) === null || _c === void 0 ? void 0 : _c.value }) : react_1.default.createElement(react_1.default.Fragment, null))))),
            react_1.default.createElement("div", { className: "col-12 content-padding footer-bottom" },
                react_1.default.createElement("div", { className: 'row footer-content py-9' },
                    react_1.default.createElement("div", { className: 'socialLinks col-12 col-md-6 py-md-0' },
                        react_1.default.createElement("nav", { className: 'd-flex justify-content-center justify-content-md-start' }, socialLinks)),
                    react_1.default.createElement("div", { className: 'col-12 col-md-6 mt-8 mb-0 mt-md-0 text-md-end' },
                        "\u00A9\u00A0",
                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.settings, field: "footerCopyrightText" }),
                        "\u00A0",
                        (new Date()).getFullYear())))));
};
exports.Footer = Footer;
exports.default = exports.Footer;
